import { router } from '../../main';

const state = {
    // Default selected pill is always set to all
    activePill: 'p-all'
}

const getters = {
    // why does this work??? what are all the lambdas for? why is category passed in like this
    isActive: state => category => state.activePill == category
}

const actions = {
    filterBy({ commit, state }, category) {
        // Update pill selected then show FilteredResults component
        commit('setActive', category)
        if (state.activePill === 'p-all') {
            router.push('/')
        } else {
            router.push('/filter').catch(err => {
                //catch error but do nothing when navigating to the same destination
                err
            })
        }

    }
}

const mutations = {
    setActive: (state, category) => {
        state.activePill = category
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}